import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { HighFitBadge } from 'src/App/AppPageBlock/HighFitBadge';
import { MarkdownContent } from 'src/libs/MarkdownContent';

import translations from './.vocab';

type Props = {
  highFitSummary: string;
};

export const HighFitCalloutMobile: FC<Props> = ({ highFitSummary }) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <HighFitBadge variant="badge" />
      <MarkdownContent content={highFitSummary} />
      <Text size="small" tone="secondary">
        {t(
          "The summary is AI-generated based on info from the applicant's CV, profile and screening question responses. AI-generated content may be inaccurate or inappropriate, so it's your responsibility to review the output. You're responsible for making all hiring decisions.",
        )}
      </Text>
    </Stack>
  );
};
